<template>
  <div class="main-container">

    <div class="container">
      <div class="column-75 page-middle">
        <h2>SWEESPTAKES ENDED</h2>
        <h4>This sweepstakes ended on 3/31/2023.</h4>
      </div>
    </div>
    
  </div>
</template>

<script>
    import {form_methods, post_request, requests_methods, validation} from "../mixins/requests";
    import {elements_classes} from '../mixins/elements_classes'

    import Subscribe_form from '../components/Subscribe_form'

    export default {
        name: "ended",
        mixins: [form_methods, post_request, requests_methods, validation, elements_classes],
        components: {
            'subscribe_form': Subscribe_form,
        },
        data(){
            return{
                // this_page: 'ended'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        }
    }
</script>

<style scoped>
</style>